var map = {
	"./Google.png": 126,
	"./ambedkarlabfoundation.jpeg": 127,
	"./b.png": 128,
	"./bauddhikgeeks-transparent.png": 129,
	"./bauddhikgeeks.png": 130,
	"./buld.jpg": 131,
	"./crest-1.png": 132,
	"./crest.png": 133,
	"./cwoc.png": 134,
	"./flutter.png": 135,
	"./gdg.png": 136,
	"./genai.jpg": 137,
	"./github.png": 138,
	"./googleAssistant.jpg": 139,
	"./google_logo.png": 140,
	"./iit.png": 141,
	"./ino.png": 142,
	"./linkedin.png": 143,
	"./localguide.gif": 144,
	"./localguide.png": 145,
	"./mathworks.png": 146,
	"./mern.png": 147,
	"./mongo.png": 148,
	"./nptel.jpg": 149,
	"./postman.jpg": 150,
	"./postman.png": 151,
	"./ram-crop.png": 152,
	"./smartbridge.png": 153,
	"./ssec.png": 154,
	"./vitronix.png": 155
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;